import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import loadingGif from '../assets/img/loading-pinwheel.gif'
import '../assets/css/components/async-elements.css'

// AsyncElements renders two different components based on a given loading state. One component
// represents a temporary loading state while the other is the component that the user is
// intended to interact with. Eg, the child component will render the page and the loading component
// could simply be a centered pinwheel gif.
//
// By default, as long as AsyncElements is not unloaded, subsequent isLoading=true
// updates will not trigger child components to re-render. This is useful if you
// need to fetch data again but don't want to completely rerender the contents
// of the fetch container. This behavior can be disabled by setting the prop alwaysUpdate to true.
class AsyncElements extends Component {
  constructor(props) {
    super(props)
    this.state = { hasUpdated: false }
  }

  componentDidUpdate() {
    if(!this.state.hasUpdated && !this.props.isLoading){
      this.setState((prevState, props) => ({ hasUpdated: true }))
    }
  }

  defaultLoadingComponent = ()=>
    <div className='async-loading'>
      <img src={loadingGif} className={`${this.props.pinwheelSize} loading`}/>
      {this.props.loadingMessage && <h1>{this.props.loadingMessage}</h1>}
    </div>

  shouldUnloadChildren = ()=>!this.state.hasUpdated || this.props.alwaysUpdate

  render() {
    const { loadingMessage, loadingComponent, alwaysUpdate, children, isLoading, fetchError, pinwheelSize } = this.props
    if(isLoading && this.shouldUnloadChildren()) {
      return _.isEmpty(loadingComponent) ? this.defaultLoadingComponent() : loadingComponent
    } else if (fetchError && this.shouldUnloadChildren()) {
      return(
        <div className='async-loading load-error'>
          <h1>{fetchError.message}</h1>
          <p>If you believe this is an application error, please contact us on Drift or <a href='https://immersedgames.zendesk.com/hc/en-us'>check support</a>.</p>
        </div>
      )
    } else {
      return children
    }
  }
}

const { oneOfType, element, object, bool, string, node } = PropTypes
AsyncElements.propTypes = {
  children:         node.isRequired,
  isLoading:        bool.isRequired,
  loadingComponent: oneOfType([element, object]),
  loadingMessage:   string,
  alwaysUpdate:     bool,
  pinwheelSize:     string
}

AsyncElements.defaultProps = {
  pinwheelSize: 'large',
  alwaysUpdate: false
}

export default AsyncElements
